import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import NavigateToNodeButton from '../NavigateToNodeButton';
import NodeImage from '../NodeImage';

const FolderChild = ({ node, orderer, onDelete }) => (
  <tr>
    <td className="two wide">
      <NavigateToNodeButton node={node} />
    </td>
    <td className="seven wide">
      <h3 className="ui image header">
        <NodeImage node={node} />
        <div className="content contentTitle">{node.title}</div>
      </h3>
    </td>
    <td className="two wide" />
    <td className="two wide">{orderer}</td>
    <td className="three wide right aligned">
      <div className="ui tiny buttons">
        <Link to={`/nodes/${node.id}/edit`} className="ui labeled icon button">
          <i className="edit icon" />Editer
        </Link>
        <button className="ui red icon button" onClick={onDelete}>
          <i className="remove icon" />Supprimer
        </button>
      </div>
    </td>
  </tr>
);

FolderChild.propTypes = {
  node: PropTypes.object.isRequired,
  orderer: PropTypes.element.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default FolderChild;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/child/FolderChild.js